import { render, staticRenderFns } from "./Proizvodi.vue?vue&type=template&id=6ead8996&"
import script from "./Proizvodi.vue?vue&type=script&lang=js&"
export * from "./Proizvodi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports